<template>
  <!--游戏特色-->
  <div
    class="pn pn3"
    style="overflow:hidden"
  >
    <div class="pn-in">
      <div class="pn-hd">
        <p class="tit">
          <img
            src="../../assets/images/tit3.png"
            alt=""
          >
        </p>
      </div>
      <div class="pn-bd">
        <div
          class="center js-center slick-initialized slick-slider slick-dotted"
          role="toolbar"
          style="margin-top:50px"
        >
          <div
            aria-live="polite"
            class="slick-list draggable"
            style="padding: 0px;"
          >
            <ul>
              <viewer :images="gameImgList">
                <li
                  v-for="(item,index) in gameImgList"
                  :key="index"
                  style="width:380px; height:250px;float:left; padding:10px"
                >
                  <img
                    :src="item.picUrl"
                    :key="index"
                    style="width:380px; height:240px;cursor: pointer;border-radius: 8px;"
                  >
                  <h3 style="width:380px;display:block;text-align:center;line-height:30px">
                    {{ item.title }}
                  </h3>
                </li>
              </viewer>
              <!-- <figure class="imghvr-slide-up">
                <img
                  :src="item.picUrl"
                  style="width:380px;height:250px;border-radius: 10px;"
                >
                <figcaption style="border-radius: 9px;">
                  <h3>{{ item.title }}</h3>
                  <p />
                </figcaption>
              </figure> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--/游戏特色-->
</template>
<script>

export default {
  created () {
    this.getImgList()
  },
  data () {
    return {
      gameImgList: [],
      swiperOption: {
        effect: 'coverflow',
        slidesPerView: 3,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true
        },
        // 显示分页
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        // // 设置点击箭头
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // 自动轮播
        autoplay: {
          delay: 2000,
          // 当用户滑动图片后继续自动轮播
          disableOnInteraction: false
        },
        // 开启循环模式
        loop: true
      }
    }
  },
  methods: {
    getImgList () {
      this.$api.getIndexPicList().then(res => {
        this.gameImgList = res.data
      })
    },
    handleClose () {

    }
  }
}
</script>
<style scoped>
@import url(../../assets/css/imagehover.css);
.pn3{
  height:760px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/line3.vue